import { combineReducers } from "redux";

import { locale } from "./locale";
import { breadcrumb } from "./breadcrumb";
import { currency } from "./currency";

const shared = combineReducers({ locale, breadcrumb, currency });
export default shared;
